import type { FandomHost } from "host";

export function getInstantConfig() {
  if (window.icbm?.config) {
    return Promise.resolve(window.icbm);
  }

  return new Promise<NonNullable<FandomHost["icbm"]>>((resolve) => {
    const listener = () => {
      resolve(window.icbm!);
      window.removeEventListener("instantConfigLoaded", listener);
    };
    window.addEventListener("instantConfigLoaded", listener);
  });
}
